"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LATAM = exports.Africa = exports.Asia = exports.Europe = void 0;
exports.Europe = [
    "at",
    "be",
    "bg",
    "hr",
    "cy",
    "cz",
    "dk",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "hu",
    "ie",
    "it",
    "lv",
    "lt",
    "lu",
    "mt",
    "nl",
    "pl",
    "pt",
    "ro",
    "sk",
    "si",
    "es",
    "se",
    "gb",
    "ua",
    "rs",
    "mk",
    "me",
    "mc",
    "ba",
    "ch",
    "is",
    "no",
    "by",
    "ad",
    "ru",
    "al",
    "sm",
    "xk",
    "gi",
];
exports.Asia = [
    "af",
    "am",
    "az",
    "bh",
    "bd",
    "bt",
    "bn",
    "kh",
    "cn",
    "ge",
    "hk",
    "in",
    "id",
    "ir",
    "iq",
    "il",
    "jp",
    "jo",
    "kz",
    "kw",
    "kg",
    "la",
    "lb",
    "mo",
    "my",
    "mv",
    "mn",
    "mm",
    "np",
    "kp",
    "om",
    "pk",
    "ph",
    "qa",
    "sa",
    "sg",
    "kr",
    "lk",
    "sy",
    "tw",
    "tj",
    "th",
    "tr",
    "tm",
    "ae",
    "uz",
    "vn",
    "ye",
];
exports.Africa = [
    "dz",
    "ao",
    "bw",
    "bi",
    "cm",
    "cv",
    "cf",
    "td",
    "km",
    "yt",
    "cg",
    "cd",
    "bj",
    "gq",
    "et",
    "er",
    "dj",
    "ga",
    "gm",
    "gh",
    "gn",
    "ci",
    "ke",
    "ls",
    "lr",
    "ly",
    "mg",
    "mw",
    "ml",
    "mr",
    "mu",
    "ma",
    "mz",
    "na",
    "ne",
    "ng",
    "gw",
    "re",
    "rw",
    "sh",
    "st",
    "sn",
    "sc",
    "sl",
    "so",
    "za",
    "zw",
    "ss",
    "eh",
    "sd",
    "sz",
    "tg",
    "tn",
    "ug",
    "eg",
    "tz",
    "bf",
    "zm",
];
exports.LATAM = [
    "ag",
    "ar",
    "aw",
    "bs",
    "bb",
    "bz",
    "bo",
    "br",
    "ky",
    "cl",
    "co",
    "cr",
    "cu",
    "dm",
    "do",
    "ec",
    "sv",
    "gf",
    "gd",
    "gp",
    "gt",
    "gy",
    "ht",
    "hn",
    "jm",
    "mq",
    "mx",
    "ni",
    "pa",
    "py",
    "pe",
    "pr",
    "bl",
    "kn",
    "lc",
    "vc",
    "sr",
    "tt",
    "tc",
    "uy",
    "ve",
    "vi",
];
//# sourceMappingURL=continentsCountriesISOCodes.js.map